import React from 'react';
import styled from 'styled-components';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { theme } from '../../styles/theme';
import { convertToVwWeb } from '../../Utils/responsive';
import loadingLottie from '../../assets/Icon/lottie/Insider-loading.lottie';

const stripEllipsis = (value: string) => value.replace(/\.+$/, '');

export type CancelSaveButtonsProps = {
  onCancel: () => void;
  onSave: () => void;
  saving?: boolean;
  savingLabel?: string;
  disabled?: boolean;
  platform: 'web' | 'mob';
  cancelLabel?: string;
  saveLabel?: string;
};

const Wrapper = styled.div`
  display: flex;
  gap: ${convertToVwWeb(10)};
`;

const CancelBtn = styled.button`
  display: flex;
  width: 130px;
  height: 54px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid ${theme.colors.grayScale[40]};
  background: ${theme.colors.grayScale[0]};
  color: ${theme.colors.grayScale[70]};
  ${theme.typography.contents.medium20};
  cursor: pointer;

  &:hover:not(:disabled) {
    background: ${theme.colors.grayScale[10]};
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

const SaveBtn = styled.button<{ $saving?: boolean }>`
  display: flex;
  width: 130px;
  height: 54px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  border-radius: 4px;
  background: ${theme.colors.primaryBlue[80]};
  color: ${theme.colors.grayScale[0]};
  border: none;
${theme.typography.button.regular20}
  cursor: pointer;

  &:hover:not(:disabled) {
    background: ${theme.colors.primaryBlue[70]};
  }
  &:disabled {
    cursor: not-allowed;
    background: ${({ $saving }) => ($saving ? '#EBFCFF' : theme.colors.grayScale[30])};
    color: ${({ $saving }) => ($saving ? '#2BC2E1' : theme.colors.grayScale[50])};
  }
`;

const LoadingIcon = styled(DotLottieReact)`
  display: inline-flex;
`;

const CancelSaveButtons = ({
  onCancel,
  onSave,
  saving = false,
  savingLabel = '저장 중...',
  disabled = false,
  platform,
  cancelLabel = '취소',
  saveLabel = '저장',
}: CancelSaveButtonsProps) => {
  const cleanedSavingLabel = stripEllipsis(savingLabel);
  return (
    <Wrapper>
      <CancelBtn type="button" onClick={onCancel} disabled={saving}>
        {cancelLabel}
      </CancelBtn>
      <SaveBtn
        type="button"
        onClick={onSave}
        disabled={disabled || saving}
        $saving={saving}
        aria-busy={saving}
        aria-label={saving ? cleanedSavingLabel : saveLabel}
      >
        {saving ? (
          <LoadingIcon
            src={loadingLottie}
            autoplay
            loop
            aria-hidden
            style={{ width: 12, height: 12 }}
          />
        ) : saveLabel}
      </SaveBtn>
    </Wrapper>
  );
};

export default CancelSaveButtons;
